import React, { useEffect, useMemo, useState } from 'react';

interface OfficialAvatarProps {
  name: string;
  photoUrl?: string | null;
  alt?: string;
  className?: string;
  imgClassName?: string;
  initialsClassName?: string;
}

function buildInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
}

const OfficialAvatar: React.FC<OfficialAvatarProps> = ({
  name,
  photoUrl,
  alt = '',
  className = '',
  imgClassName = '',
  initialsClassName = '',
}) => {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [photoUrl]);

  const initials = useMemo(() => buildInitials(name), [name]);

  if (!photoUrl || broken) {
    return (
      <div className={className} aria-label={alt || name} role="img">
        <span className={initialsClassName}>{initials}</span>
      </div>
    );
  }

  return (
    <img
      src={photoUrl}
      alt={alt}
      className={imgClassName}
      onError={() => setBroken(true)}
    />
  );
};

export default OfficialAvatar;
